import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { applyPageMeta, getPageMeta } from "@/lib/pageMeta";

const PageMeta = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const meta = getPageMeta(pathname, search);
    applyPageMeta(meta);
  }, [pathname, search]);

  return null;
};

export default PageMeta;
